import { MessageCircle } from "lucide-react";
import { useLang } from "@/i18n";
import { PolicyDialog } from "@/components/legal";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-ink text-white border-t border-white/15">
      <div className="mx-auto max-w-[1600px] px-5 md:px-10 py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <div className="flex items-center gap-2">
              <span className="w-3 h-3 bg-ferrari" />
              <span style={{ fontFamily: "'Times New Roman', Times, serif" }} className="text-3xl font-bold tracking-tight">
                <span className="text-ferrari">PST</span> <span className="text-white">Pellet</span>
              </span>
            </div>
            <p className="mt-5 text-white/60 max-w-md leading-relaxed">{t.footer.tagline}</p>
            <div className="mt-5 inline-flex items-center gap-2 border border-white/25 px-4 py-2">
              <span className="w-2 h-2 bg-ferrari" />
              <span className="text-xs font-bold uppercase tracking-[0.15em] text-white/85">{t.footer.cert}</span>
            </div>
          </div>
          <div className="md:col-span-3">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-white/50">{t.footer.contatti}</div>
            <div className="mt-4 space-y-2 text-white/80">
              <a href="tel:+393316819146" className="block hover:text-ferrari transition-colors">+39 331 6819146</a>
              <a href="mailto:info@pstpellet.com" className="block hover:text-ferrari transition-colors">info@pstpellet.com</a>
              <a href="mailto:pst@pecimprese.it" className="block hover:text-ferrari transition-colors">PEC: pst@pecimprese.it</a>
              <div className="text-white/55 text-sm pt-1">P.IVA 14760760968</div>
            </div>
          </div>
          <div className="md:col-span-3">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-white/50">{t.footer.marchiLabel}</div>
            <div className="mt-4 space-y-2 text-white/80 text-sm">
              <div>TUpellet — Conifera Spagnola</div>
              <div>Fuoco nel Fuoco Gold</div>
              <div>Fuoco nel Fuoco Platin</div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/15 flex flex-col md:flex-row items-center justify-between gap-4">
          <span className="text-xs text-white/40 uppercase tracking-[0.12em] text-center md:text-left">© {year} {t.footer.copyright}</span>
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
            <PolicyDialog type="privacy">
              <button data-testid="footer-privacy-link" className="text-xs font-bold uppercase tracking-[0.12em] text-white/70 hover:text-ferrari transition-colors">{t.footer.privacy}</button>
            </PolicyDialog>
            <PolicyDialog type="cookie">
              <button data-testid="footer-cookie-link" className="text-xs font-bold uppercase tracking-[0.12em] text-white/70 hover:text-ferrari transition-colors">{t.footer.cookie}</button>
            </PolicyDialog>
            <a
              data-testid="footer-whatsapp"
              href="https://wa.me/393316819146"
              target="_blank" rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.15em] text-ferrari hover:text-white transition-colors"
            >
              <MessageCircle size={16} /> WhatsApp
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
